import { useState } from 'react';
import { useLocation, useParams } from 'react-router';
import {
  Box, Button, Card, Flex, Separator, Text, Textarea,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import api from '@services/api';

import useGetAvailableDispositionOptions from '../useGetAvailableDispositionOptions';
import DispositionOptionSelect from './DispositionOptionSelect';
import ConfirmNextDispositionDialog from './ConfirmNextDispositionDialog';
import type { DispositionOptionType } from '../types';

const DispositionForm = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispositionId = location.state.dispositionId;

  const [loading, setLoading] = useState(false);
  const [showNextDispositionDialog, setShowNextDispositionDialog] = useState(false);
  const [selectedDispositionOption, setSelectedDispositionOption] = useState<DispositionOptionType | null>(null);
  const [description, setDescription] = useState('');

  const { dispositionOptions } = useGetAvailableDispositionOptions();

  const clearData = () => {
    setSelectedDispositionOption(null);
    setDescription('');
  };

  const onDispositionClick = async () => {
    try {
      setLoading(true);
      const response = await api.post(`/campaign_execution/${id}/dispose/${dispositionId}`, {
        outcome_option_id: selectedDispositionOption?.id,
        outcome: description || undefined,
      });
      if (response.status === 200) {
        setShowNextDispositionDialog(true);
      } else {
        toast.error('Erro ao salvar tabulação. Tente novamente!');
      }
    } catch {
      toast.error('Erro ao salvar tabulação. Tente novamente!');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Card.Root
      size="sm"
      variant="subtle"
      p={4}
    >
      <Text fontSize="md" fontWeight="bold">
        Tabulação
      </Text>
      <Separator mb={6} mt={1} />

      <Box mb={4} maxW={{ base: '100%', md: 400 }}>
        <DispositionOptionSelect
          options={dispositionOptions}
          value={selectedDispositionOption}
          onChange={setSelectedDispositionOption}
        />
      </Box>

      <Textarea
        placeholder="Comentário..."
        rows={5}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        maxLength={1000}
      />

      <Flex justifyContent="flex-end" mt={4}>
        <Button bg="green.700" color="white" onClick={onDispositionClick} loading={loading}>
          Tabular
        </Button>
      </Flex>

      {showNextDispositionDialog && (
        <ConfirmNextDispositionDialog
          handleClose={() => setShowNextDispositionDialog(false)}
          afterSubmit={clearData}
        />
      )}
    </Card.Root>
  )
};

export default DispositionForm;